/* Keep brand typography available after interrupted loads and page restoration. */
(function (w, d) {
  'use strict';
  if (!d.fonts || !w.FontFace) return;
  const sheet = d.querySelector('[data-co-brand-fonts]')?.sheet;
  if (!sheet) return;
  const familyName = value => value.replace(/["']/g, '').trim();
  const records = Array.from(sheet.cssRules).filter(rule => rule.type === 5).map(rule => ({
    family: familyName(rule.style.fontFamily),
    weight: rule.style.fontWeight,
    source: rule.style.getPropertyValue('src'),
    attempts: 0,
    pending: null,
    recovered: null
  }));
  const pause = ms => new Promise(resolve => w.setTimeout(resolve, ms));
  function recover(record) {
    if (record.pending || record.recovered || record.attempts >= 2) return record.pending;
    record.pending = (async () => {
      while (record.attempts < 2 && !record.recovered) {
        const attempt = ++record.attempts;
        await pause(attempt === 1 ? 200 : 1200);
        // A failed CSS FontFace retains its rejected promise. A fresh face and
        // request are needed; calling load() on that failed face cannot retry it.
        const source = record.source.replace(/url\(["']?([^"')]+)["']?\)/g, (_, href) => {
          const url = new URL(href, d.baseURI);
          url.searchParams.set('co_font_retry', String(attempt));
          return 'url("' + url.href + '")';
        });
        try {
          const face = new FontFace(record.family, source, {weight: record.weight, style: 'normal', display: 'swap'});
          await face.load();
          d.fonts.add(face);
          record.recovered = face;
        } catch (_) { /* Keep readable fallback text; retry is deliberately bounded. */ }
      }
    })().finally(() => { record.pending = null; });
    return record.pending;
  }
  function ensure() {
    if (d.hidden) return;
    const faces = Array.from(d.fonts);
    for (const record of records) {
      if (record.recovered || record.pending) continue;
      const face = faces.find(face => familyName(face.family) === record.family && face.weight === record.weight);
      if (!face) continue;
      if (face.status === 'error') { recover(record); continue; }
      // Start the two main faces explicitly, including before client-rendered
      // page content arrives. Other weights load only when the page uses them.
      if (face.status === 'unloaded' && (record.weight === '400 600' || record.family === 'Open Sans')) {
        face.load().catch(() => recover(record));
      }
    }
  }
  w.COBrandFonts = {ensure};
  d.fonts.addEventListener('loadingerror', ensure);
  w.addEventListener('pageshow', ensure);
  w.addEventListener('online', () => { records.forEach(record => { if (!record.pending && !record.recovered) record.attempts = 0; }); ensure(); });
  d.addEventListener('visibilitychange', ensure);
  ensure();
})(window, document);
